<template>
	<sf-modal-layout class="qms-xxl fwdCkuSttsPopup" :title="getMessage_('QWCC001363')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100" style="overflow-y: hidden">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="position-relative sf-col sf-col-20">
				<buttons :scrId="scrId" class="mb-2"></buttons>
				<form-view :scrId="scrId" @Refresh="refresh"></form-view>
				<sf-card class="p-0 border-0 bg-transparent">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId"></table-view>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuStts/store/helpers';
import SearchView from './PopupContent/PopupSearch.vue';
import TableView from './PopupContent/PopupTable.vue';
import FormView from './PopupContent/PopupForm.vue';
import Buttons from './PopupContent/PopupButtons.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			isLoaded: false
		};
	},
	components: { SearchView, TableView, FormView, Buttons },
	methods: {
		...rootMethods,
		...serviceMethods,
		async open(row) {
			this.$sf_toggleLoading(true);
			this.show = true;
			try {
				this.setPopupInit_();
				this.setState_({ key: 'selectedRow', value: { ...row } });
				this.setPopupSearchParam_({ key: 'pmcNo', value: this.selectedRow.pmcNo });
				this.setPopupSearchParam_({ key: 'ipnNos', value: this.selectedRow.ipnNos });
				this.refresh();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
			}
		},
		close() {
			this.$emit('Refresh');
			this.setPopupInit_();
			this.show = false;
			this.isLoaded = false;
		},
		refresh() {
			this.$refs.searchView?.searchList();
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>
<style lang="scss">
.el-dialog__wrapper .fwdCkuSttsPopup .el-dialog__body {
	/* max-height: 97%; */
	height: 97% !important;
	max-height: unset !important;
}
</style>
